/** URLs p�blicas en el dominio de la web (deca.abmscloud.com), no en Railway. */
export function webOrigin() {
  if (typeof window !== "undefined" && window.location?.origin) {
    const { origin } = window.location;
    if (origin && !origin.includes("railway.app")) return origin;
  }
  return "https://deca.abmscloud.com";
}

export function firmarUrl(token) {
  return `${webOrigin()}/firmar/${token}`;
}

export function descargaUrl(token) {
  return `${webOrigin()}/d/${token}`;
}

/** PDF autenticado (misma cookie, visor nativo del navegador). */
export function decaPdfPath(decaId) {
  return `/api/v1/decas/${decaId}/pdf`;
}
